<script>
  import { fade } from 'svelte/transition'
  import { cubicOut } from 'svelte/easing'
  import { text_entered, hero_expanded } from '../stores'
</script>

{#if $hero_expanded && $text_entered !== ''}
  <div 
  class="start" 
  transition:fade="{{ duration: 200, easing: cubicOut }}"
  on:click>
    &rarr;
  </div>
{/if}

<style>
  .start {
    position: absolute;
    top: 1.6rem;
    left: 59.6rem;
    width: 5.8rem;
    height: 5.8rem;
    border-radius: 50%;
    background-color: var(--c-textfield-button-bg);
    color: var(--c-text-faded);
    text-align: center;
    font-family: var(--PensumSans-Bold);
    font-size: 4.7rem;
    font-weight: bold;
    line-height: 5.4rem;
    transition-property: background-color, color;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }

  .start:hover {
    cursor: pointer;
    color: var(--c-accent);
  }

  @media only screen and (max-width: 870px) {
    .start {
      left: auto;
      right: 0.6rem;
    }
  }
</style>